import ratePlatformService from '@/services/customer/ratePlatformService';

export default {
  namespaced: true,

  state: {
    rateableOrder: {
      exist: false,
      type: null,
      order_id: null,
      price: null
    }
  },

  getters: {

  },

  mutations: {
    SET_RATEABLE_ORDER (state, payload) {
      state.rateableOrder = payload;
    }
  },

  actions: {
    async checkRateableOrder ({ commit }) {
      const response = await ratePlatformService.customerGetRateableOrder();
      commit('SET_RATEABLE_ORDER', response);
    },

    async customerRatePlatform ({ state }, payload) {
      const { type: order_type, id: order_id } = state.rateableOrder;

      const method = order_type === 'order'
        ? 'customerRatePlatformOrderBooking'
        : 'customerRatePlatformOrderDelivery';

      await ratePlatformService[method](order_id, payload);
    }
  }
}
